import { axiosRequest, updateHeaders } from '@/plugins/axios-common'
import { captureUnexpectedError } from '@/utilities'

export const AuthenticationActions = {
  handleSuccessfulAuthentication ({ commit, dispatch }, response) {
    const token = response.access_token
    const user = response.user

    if (user?.reset_required) return { user: user }

    updateHeaders(token)

    commit('authSuccess', token, { root: true })
    commit('setCurrentUser', user, { root: true })
    commit(
      'setRefreshTokenExpiresAt',
      response.refresh_token_expires_in != null ? Date.now() + response.refresh_token_expires_in * 1000 : null,
      { root: true }
    )
    commit('setSessionSettings', response.session, { root: true })

    if (response.redirect_to) dispatch('handleSessionReturnTo', { returnTo: response.redirect_to }, { root: true })
  },

  loadMultifactorAuthenticationSettings ({ commit }) {
    return axiosRequest.get('/auth/settings').
      then(({ data }) => {
        commit('setMultifactorAuthenticationSettings', data)
      }).
      catch(error => {
        captureUnexpectedError(error)
        throw error
      })
  },

  requestAuthentication ({ dispatch }, { username, password, strategy, redirectTo }) {
    return axiosRequest.post('/auth/request', { username, password, redirectTo, strategy }).
      then(({ data }) => {
        if (strategy === 'none' && data?.access_token) {
          return dispatch('handleSuccessfulAuthentication', data)
        } else {
          return data
        }
      }).
      catch(error => {
        captureUnexpectedError(error)
        throw error.response
      })
  },

  verifyAuthenticationRequest ({ dispatch }, { strategy, passcode }) {
    return axiosRequest.post('/auth/verify', { strategy, passcode }).
      then(({ data }) => dispatch('handleSuccessfulAuthentication', data)).
      catch(error => {
        captureUnexpectedError(error)
        throw error.response
      })
  },
}
